var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiHappyMealLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 76,
    viewBox: "0 0 60 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ui-happy-meal-logo_svg__clip0_1466_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.173 75.5L60 32.276 55.822 16.23H4.178L0 32.276 3.827 75.5h52.346z",
    fill: "#DB0007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.822 16.229h-8.616c-.923-6.373-2.45-10.278-4.932-10.278s-4.243 3.93-5.257 10.278H22.963C21.956 9.882 20.293 5.95 17.706 5.95c-2.586 0-4.009 3.911-4.931 10.278H4.178C8.168 5.223 13.652.5 18.128.5 22.606.5 27.006 5.178 30 10.986 32.995 5.178 37.492.5 41.87.5c4.38 0 9.961 4.723 13.95 15.729zm-6.27 28.235l2.3 1.053 1.11-2.43-6.334-2.898-1.111 2.43 1.949.89C45.556 50.357 38.46 55.438 30 55.438S14.444 50.35 12.534 43.509l1.95-.89-1.112-2.43-6.335 2.898 1.111 2.43 2.3-1.053C13.23 53.593 20.93 60.154 30 60.154c9.07 0 16.777-6.562 19.552-15.69z",
    fill: "#FFBC0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ui-happy-meal-logo_svg__clip0_1466_11485"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h60v75H0z"
  })))));
}
export default SvgUiHappyMealLogo;